import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authContext } from '../components/Context/AuthContext';
import React from 'react';


const PrivateRoute = ({ children }) => {
  const { token } = useContext(authContext);
  const location = useLocation();

  if (!token) {
    // Si no hay token, lo mando al login y guardo desde dónde vino
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default PrivateRoute;
